<template>
	<div class="container-fluid">    
    <div class="row">
      <div class="col-md-12 category-bar">

        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'indice' } }" active-class="aActive">
          <span class="initial all-color">{{ $t("I") }}</span>
          <span class="text">{{ $t("Indice") }}</span>
        </router-link>

        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'libros' } }" active-class="bActive">
          <span class="initial books-color">{{ $t("L") }}</span>
          <span class="text">{{ $t("Libros") }}</span>
        </router-link>
        
        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'cine' } } " active-class="cActive">
          <span class="initial cinema-color">C</span>
          <span class="text">{{ $t("Cine y TV") }}</span>
        </router-link> 
        
        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'musica' } }" active-class="mActive">
          <span class="initial music-color">M</span>
          <span class="text">{{ $t("Música") }}</span>
        </router-link>

        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'infantil' } }" active-class="iActive">
          <span class="initial infantile-color">I</span>
          <span class="text">{{ $t("Infantil") }}</span>
        </router-link>

        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'juegos' } }" active-class="gActive">
          <span class="initial games-color">J</span>
          <span class="text">{{ $t("Juegos") }}</span>
        </router-link>

        <!-- <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'series' } }" active-class="sActive">
          <span class="initial series-color">S</span>
          <span class="text">{{ $t("Series") }}</span>
        </router-link>

        <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'documentales' } }" active-class="dActive">
          <span class="initial docu-color">D</span>
          <span class="text">{{ $t("Documentales") }}</span>
        </router-link> -->

      </div>
    </div> 

    <div class="row sub-all" v-if="subIndex">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuIndice" :key="index">
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/indice' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link :to="'/'+ getLocale + '/catalogo/indice' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
              </li>
            </ul>            
          </li>
        </ul>
      </nav>
    </div>

    <div class="row sub-cinema" v-if="subCinema">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuCine" :key="index"><!-- <span>{{ item.nombre }}</span> -->
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/cine' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <!-- <router-link :to="'/'+ getLocale + '/catalogo/cine' + subitem.link">{{ subitem.nombre }}</router-link> -->
                <router-link v-if="subitem.link" :to="'/'+ getLocale + '/catalogo/cine' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
                <a v-else :href="getPath" v-on:click.prevent.stop>{{ subitem.nombre }}</a>
                <ul v-if="subitem.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
                  <li v-for="(subitem2, index) in subitem.subapartados" :key="index">
                    <router-link :to="'/'+ getLocale + '/catalogo/cine' + subitem2.link">{{ subitem2.nombre }} <div v-if=" subitem2.num > 0 " class="c-quantity">( {{ subitem2.num }} )</div></router-link>
                  </li>
                </ul>
              </li>
            </ul>
            
          </li>
        </ul>
      </nav>
    </div>

    <div class="row sub-music" v-if="subMusic">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuMusica" :key="index"><!-- <span>{{ item.nombre }}</span> -->
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/musica' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>            
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link :to="'/'+ getLocale + '/catalogo/musica' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
              </li>
            </ul>
            
          </li>
        </ul>
      </nav>
    </div>

    <div class="row sub-infantile" v-if="subInfantile">
      <nav>
        <ul class="main-menu products">

          <li v-for="(item, index) in menuInfantil" :key="index"><!-- <span>{{ item.nombre }}</span> -->

            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/infantil' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>

            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">

              <li v-for="(subitem, index) in item.subapartados" :key="index">

                <router-link v-if="subitem.link" :to="'/'+ getLocale + '/catalogo/infantil' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
                <a v-else :href="getPath" v-on:click.prevent.stop>{{ subitem.nombre }}</a>

                <ul v-if="subitem.subapartados" :class="{ scroll : item.subapartados.length > 7 }">

                  <li v-for="(subitem2, index) in subitem.subapartados" :key="index">

                    <router-link v-if="subitem2.link" :to="'/'+ getLocale + '/catalogo/infantil' + subitem2.link">{{ subitem2.nombre }} <div v-if=" subitem2.num > 0 " class="c-quantity">( {{ subitem2.num }} )</div></router-link>
                    <a v-else :href="getPath" v-on:click.prevent.stop>{{ subitem.nombre }}</a>

                    <ul v-if="subitem2.subapartados" :class="{ scroll : item.subapartados.length > 7 }">

                      <li v-for="(subitem3, index) in subitem2.subapartados" :key="index">

                        <router-link :to="'/'+ getLocale + '/catalogo/infantil' + subitem3.link">{{ subitem3.nombre }} <div v-if=" subitem3.num > 0 " class="c-quantity">( {{ subitem3.num }} )</div></router-link>

                      </li>
                    </ul> 

                  </li>
                </ul> 
              </li>
            </ul>
            
          </li>
        </ul>
      </nav>
    </div> 

    <!-- 
      ANTES DE SUB SUB SUB
      <div class="row sub-infantile" v-if="subInfantile">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuInfantil" :key="index">
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/infantil' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link v-if="subitem.link" :to="'/'+ getLocale + '/catalogo/infantil' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
                <a v-else :href="getPath" v-on:click.prevent.stop>{{ subitem.nombre }}</a>
                <ul 
                  v-if="subitem.subapartados" 
                  :class="{ scroll : item.subapartados.length > 7 }"
                >
                  <li 
                    v-for="(subitem2, index) in subitem.subapartados" :key="index">
                      <router-link :to="'/'+ getLocale + '/catalogo/infantil' + subitem2.link">{{ subitem2.nombre }} <div v-if=" subitem2.num > 0 " class="c-quantity">( {{ subitem2.num }} )</div></router-link>
                  </li>
                </ul>
              </li>
            </ul>
            
          </li>
        </ul>
      </nav>
    </div>  -->

    <div class="row sub-books" v-if="subBooks">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuLibros" :key="index"><!-- <span>{{ item.nombre }}</span> -->
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/libros' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="'#'+getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados">  <!-- :class="{ scroll : item.subapartados.length > 7 }" -->
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link v-if="subitem.link" :to="'/'+ getLocale + '/catalogo/libros' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
                <a v-else :href="getPath" v-on:click.prevent.stop>{{ subitem.nombre }}</a>
                <ul v-if="subitem.subapartados" :class="{ scroll : item.subapartados.length > 7 }"> <!--  -->
                  <li v-for="(subitem2, index) in subitem.subapartados" :key="index">
                    <router-link :to="'/'+ getLocale + '/catalogo/libros' + subitem2.link">{{ subitem2.nombre }} <div v-if=" subitem2.num > 0 " class="c-quantity">( {{ subitem2.num }} )</div></router-link>
                  </li>
                </ul>
              </li>
            </ul>

            <!-- 
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="subitem in item.subapartados">
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'libros' }, query = subitem.link }">{{ subitem.elemento }}</router-link>
              </li>
            </ul>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="subitem in item.subapartados">
                <router-link :to="'/'+ getLocale + '/catalogo/libros' + subitem.link + ''">{{ subitem.elemento }}</router-link>
              </li>
            </ul>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="subitem in item.subapartados">
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: 'libros' } }">{{ subitem.elemento }}</router-link>
              </li>
            </ul>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="subitem in item.subapartados">
                <router-link :to="subitem.link">{{ subitem.elemento }}</router-link>
              </li>
            </ul> -->
            
          </li>
        </ul>
      </nav>
    </div>

    <!-- <div class="row sub-series" v-if="subSeries">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuSeries" :key="index">
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/series' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link :to="'/'+ getLocale + '/catalogo/series' + subitem.link">{{ subitem.nombre }}</router-link>
              </li>
            </ul>
            
          </li>
        </ul>
      </nav>
    </div>  -->

    <!-- <div class="row sub-documentaries" v-if="subDocumentaries">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuDocumentales" :key="index">
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/documentales' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados" :class="{ scroll : item.subapartados.length > 7 }">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link :to="'/'+ getLocale + '/catalogo/documentales' + subitem.link">{{ subitem.nombre }}</router-link>
              </li>
            </ul>
            
          </li>
        </ul>
      </nav>
    </div>  -->

    <div class="row sub-games" v-if="subGames">
      <nav>
        <ul class="main-menu products">
          <li v-for="(item, index) in menuJuegos" :key="index">
            <router-link v-if="item.link" :to="'/'+ getLocale + '/catalogo/juegos' + item.link">{{ item.nombre }}</router-link>
            <a v-else :href="'#'+getPath" v-on:click.prevent.stop>{{ item.nombre }}</a>
            <ul v-if="item.subapartados">
              <li v-for="(subitem, index) in item.subapartados" :key="index">
                <router-link v-if="subitem.link" :to="'/'+ getLocale + '/catalogo/juegos' + subitem.link">{{ subitem.nombre }} <div v-if=" subitem.num > 0 " class="c-quantity">( {{ subitem.num }} )</div></router-link>
                <a v-else :href="getPath" v-on:click.prevent.stop>{{ subitem.nombre }}</a>
                <ul v-if="subitem.subapartados" :class="{ scroll : item.subapartados.length > 7 }"> <!--  -->
                  <li v-for="(subitem2, index) in subitem.subapartados" :key="index">
                    <router-link :to="'/'+ getLocale + '/catalogo/juegos' + subitem2.link">{{ subitem2.nombre }} <div v-if=" subitem2.num > 0 " class="c-quantity">( {{ subitem2.num }} )</div></router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>

    <menu-productos-expandido v-if="subCategory"></menu-productos-expandido>

  </div>
</template>

<i18n>
{
  "es": {
    "Indice": "Indice",
    "Cine y TV": "Cine y TV",
    "Música": "Música",
    "Infantil": "Infantil",
    "Libros": "Libros",
    "Series": "Series",
    "Documentales": "Documentales",
    "Juegos": "Juegos",
    "I": "I",
    "C": "C",
    "M": "M",
    "L": "L",
    "S": "S",
    "D": "D",
    "J": "J"
  },
  "en": {
    "Indice": "Index",
    "Cine y TV": "Cinema & TV",
    "Música": "Music",
    "Infantil": "Infantile",
    "Libros": "Books",
    "Series": "Series",
    "Documentales": "Documentaries",
    "Juegos": "Games",
    "I": "I",
    "C": "C",
    "M": "M",
    "L": "B",
    "S": "S",
    "D": "D",
    "J": "G"
  },
  "ca": {
    "Indice": "Índex",
    "Cine y TV": "Cinema i TV",
    "Música": "Música",
    "Infantil": "Infantil",
    "Libros": "Llibres",
    "Series": "Sèries",
    "Documentales": "Documentals",
    "Juegos": "Jocs",
    "I": "I",
    "C": "C",
    "M": "M",
    "L": "L",
    "S": "S",
    "D": "D",
    "J": "J"
  }
}
</i18n>

<script>
  import axios from 'axios';
  import { mapState, mapGetters } from 'vuex';
  import MenuProductosExpandido from './MenuProductosExpandido.vue'

	export default {
    components: { MenuProductosExpandido },
    data() {
      return {
        menu: {},
        menuIndice: {},
        menuCine: {},
        menuMusica: {},
        menuInfantil: {},
        menuLibros: {},
        menuSeries: {},
        menuDocumentales: {},
        menuJuegos: {},
        subIndex: false,
        subCinema: false,
        subMusic: false,
        subInfantile: false,
        subBooks: false,
        subSeries: false,
        subDocumentaries: false,
        subGames: false,
        aIsActive: false,
        cIsActive: false,
        mIsActive: false,
        iIsActive: false,
        bIsActive: false,
        sIsActive: false,
        dIsActive: false,
        gIsActive: false,
        category: '',
        subCategory: '',
        idioma: '',
      }
    },
    mounted(){
      /*this.cargarMenu(this.$store.getters.menuState.idioma);
      this.setActiveMenu(this.$store.getters.menuState.categoria);
      this.setLinkData();*/
      this.cargarMenu(this.menuState.idioma);
      this.setActiveMenu(this.menuState.categoria);
      this.category = this.menuState.categoria;
      this.subCategory = this.menuState.subCategoria;
      this.idioma = this.menuState.idioma;
      
    },
    computed: { 
      //...mapGetters({ menuState: 'menuState', getPath: 'getgetPath'}, ['getApiUrl', 'getLocale'] ),
      ...mapGetters( ['menuState', 'getPath', 'getApiUrl', 'getLocale'] ),
    },
    methods:{
      cargarMenu(idioma){
        //axios.get('http://192.168.1.200/tatarana/api/menu/'+idioma)
        /*?i='+idioma*/
        //axios.get('src/json/menu-productos-light.json')
        axios.get(this.getApiUrl + this.getLocale + '/menu')
          .then( (respuesta) =>{
            this.menu = respuesta.data.menu;
            this.menuIndice = this.menu[0].menu_item;
            this.menuCine = this.menu[1].menu_item;
            this.menuMusica = this.menu[2].menu_item;
            this.menuInfantil = this.menu[3].menu_item;
            this.menuLibros = this.menu[4].menu_item;
            this.menuSeries = this.menu[5].menu_item;
            this.menuDocumentales = this.menu[6].menu_item;
            this.menuJuegos = this.menu[7].menu_item;
            //console.log(respuesta.data);
          })
      },
      setActiveMenu(categoria){
        this.subIndex = this.subCinema = this.subMusic = this.subInfantile = false;
        this.subBooks = this.subSeries = this.subDocumentaries = false;
        this.subGames = false;

        switch(categoria){
          case "indice": this.subIndex = true; break;
          case "cine": this.subCinema = true; break;
          case "musica": this.subMusic = true; break;
          case "infantil": this.subInfantile = true; break;
          case "libros": this.subBooks = true; break;
          case "series": this.subSeries = true; break;
          case "documentales": this.subDocumentaries = true; break;
          case "juegos": this.subGames = true; break;
          default: break;
        }
      },
    },
    watch: {
      menuState: function() { 
        this.category = this.menuState.categoria;
        this.subCategory = this.menuState.subCategoria;
        this.language = this.menuState.idioma;
        this.setActiveMenu(this.menuState.categoria);
      },
      getLocale: function(newValue, oldValue){
        //console.log('oldValue: ' + oldValue + ' | newValue: ' + newValue )
        if(newValue !== undefined){
          this.cargarMenu(newValue);
        }
      }
    }
  }
</script>
<style scoped>
  .c-quantity{ 
    display: inline-block; 
    font-weight: 100;
    color: #CCC;
    margin-left: 5px;
  }
</style>
